import { useTranslations } from "next-intl";
import Link from "next/link";

const Breadcrumb = ({ title, pages }: { title: string; pages: string[] }) => {
  const t = useTranslations("Home");

  return (
    <div className="overflow-hidden shadow-breadcrumb">
      <div>
        <div className="w-full px-4 py-5 mx-auto max-w-7xl sm:px-6 xl:px-0 xl:py-10">
          <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
            <h1 className="text-xl font-semibold capitalize text-dark sm:text-2xl xl:text-custom-2">
              {title}
            </h1>

            <ul className="flex items-center gap-2">
              <li className="text-custom-sm hover:text-blue">
                <Link href="/">{t("title")} /</Link>
              </li>

              {pages.length > 0 &&
                pages.map((page, key) => (
                  <li
                    className="capitalize text-custom-sm last:text-blue"
                    key={key}
                  >
                    {page}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
